"use strict";

exports.__esModule = true;
exports.default = getEnv;

function getEnv(origin) {
  if (/^https?:\/\/(stage|1)(.*?)\.gaoding\.com$/.test(origin)) {
    return 'release';
  } else if (/\.gaoding\.com$/.test(origin) && !/dev.*?\.gaoding/.test(origin)) {
    return 'production';
  } else if (/\.gaoding\.localhost$/.test(origin)) {
    return 'localhost';
  } else {
    return 'development';
  }
}